module.exports = __webpack_public_path__ + "img/1153.efe5524a.gif";